import { useMemo } from "react";
import { useInView } from "react-intersection-observer";

const YouTubeEmbed = ({ url }) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Load only once when in view
    threshold: 0.1      // Trigger when 10% visible
  });

  const embedUrl = useMemo(() => {
    if (!url) return "";
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === "youtu.be") {
        return `https://www.youtube.com/embed${urlObj.pathname}`;
      }
      if (urlObj.hostname.includes("youtube.com") && urlObj.searchParams.has("v")) {
        return `https://www.youtube.com/embed/${urlObj.searchParams.get("v")}`;
      }
      return "";
    } catch (error) {
      console.error("Invalid YouTube URL:", url);
      return "";
    }
  }, [url]);

  return (
    <div ref={ref} className="w-full h-[180px] bg-gray-100 rounded-md shadow-md">
      {inView && embedUrl && (
        <iframe
          width="100%"
          height="180"
          src={embedUrl}
          title="Exercise Demo"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="rounded-md shadow-md"
        />
      )}
    </div>
  );
};

export default YouTubeEmbed;
